import React, { useEffect } from 'react';
import { Button, Table, TableBody, TableCell, TableContainer, TableRow, Typography, TableHead } from '@mui/material';
import {
  tableCell,
  tableRowStyle,
  tableBtnDownload,
  tableBtnLook,
  tableCellText,
  tableHeaderCell,
} from './PaymentOrdersTable.sx';
import { grey10, grey, white } from 'app/components/ThemeProvider/colors';
import usePaymentOrdersPage from 'app/pages/PaymentOrdersPage/usePaymentOrdesPage';
import DownloadIcon from 'app/components/Icons/DownloadIcon';
import logger from 'app/utils/logger';

interface TableHeader {
  id: string;
  name: string;
}

interface TableRowOrders {
  block_date: string;
  name: string;
  number: string;
  amount: string;
  iban: string;
  currency: string;
  type?: string;
}

interface Props {
  tableRow: TableRowOrders[];
  tableHeader: TableHeader[];
  getFile: any;
}

const PaymentOrdersTable = (props: Props) => {
  const { tableRow, tableHeader, getFile } = props;

  useEffect(() => {}, [tableRow]);

  return (
    <TableContainer
      sx={{
        backgroundColor: 'white',
        boxShadow: '2px 2px 32px rgba(0, 0, 0, 0.06)',
        marginTop: '20px',
        minHeight: '627px',
        borderRadius: '8px',
      }}
    >
      <Table sx={{minWidth: '1036px'}}>
        <TableHead>
          <TableRow sx={tableRowStyle}>
            {tableHeader.map((item, index) => (
              <TableCell key={item.id} sx={tableHeaderCell}>
                <Typography sx={{ fontSize: '15px', color: grey, lineHeight: '1' }}>{item.name}</Typography>
              </TableCell>
            ))}
            <TableCell sx={{ ...tableCell, width: '50px' }}></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {tableRow.map((row, index) => (
            <TableRow
              key={index}
              sx={
                (index + 1) % 2 !== 0
                  ? {
                      ...tableRowStyle,
                      background: grey10,
                    }
                  : tableRowStyle
              }
            >
              <TableCell sx={tableCell}>
                <Typography sx={{...tableCellText, width: '90px'}}>{row.block_date}</Typography>
              </TableCell>
              <TableCell sx={{...tableCell, width: '60px'}}>
                <Typography sx={{...tableCellText}}>{row.name}</Typography>
              </TableCell>
              <TableCell sx={{...tableCell, width: '120px'}}>
                <Typography sx={tableCellText}>{row.number}</Typography>
              </TableCell>
              <TableCell sx={tableCell}>
                <Typography sx={tableCellText}>{row.amount}</Typography>
              </TableCell>
              <TableCell sx={{ ...tableCell, width: '270px' }}>
                <Typography sx={{ ...tableCellText, lineHeight: '1.5' }}>{row.iban}</Typography>
              </TableCell>
              <TableCell sx={{ ...tableCell, width: '130px' }}>
                <Typography sx={tableCellText}>{row.currency}</Typography>
              </TableCell>
              <TableCell sx={{ ...tableCell, flexDirection: 'row', gap: '12px', width: '50px' }}>
                {/*<Button color={'tertiary'} sx={tableBtnDownload}>*/}
                {/*  <DownloadIcon color={'secondary'} />*/}
                {/*  Yüklə*/}
                {/*</Button>*/}
                <Button
                  onClick={() => {
                    getFile(row.number);
                  }}
                  size={'medium'}
                  color={'info'}
                  variant={'contained'}
                >
                  Bax
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PaymentOrdersTable;
